import React from 'react';
import { CheckCircle2, Circle, AlertTriangle } from 'lucide-react';
import { Lead } from '../../types/lead';
interface EvidenceChecklistProps {
  lead: Lead;
  onClose: () => void;
  onConfirm: () => void;
}
export function EvidenceChecklist({
  lead,
  onClose,
  onConfirm
}: EvidenceChecklistProps) {
  const checks = [{
    id: 'A',
    label: 'Decisor identificado',
    passed: !!lead.DECISOR_NOMBRE
  }, {
    id: 'B',
    label: 'Canal verificado',
    passed: lead.VERIFICADO
  }, {
    id: 'C',
    label: 'Necesidad aceptada',
    passed: !!lead.NOTA_CARENCIA
  }, {
    id: 'D',
    label: 'Micro-acción con fecha',
    passed: !!lead.MICRO_ACCION_DATE
  }, {
    id: 'E',
    label: 'Señal de intención textual',
    passed: !!lead.TEXTO_EVIDENCIA
  }];
  const allPassed = checks.every(c => c.passed);
  return <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-564">
      <div className="bg-growthly-surface rounded-xl shadow-2xl max-w-md w-full overflow-hidden border border-white/10" data-id="element-565">
        <div className="p-5 border-b border-white/5 bg-growthly-panel" data-id="element-566">
          <h3 className="text-[18px] font-semibold text-growthly-text flex items-center" data-id="element-567">
            Evidencia Requerida
            {!allPassed && <AlertTriangle className="w-5 h-5 text-growthly-red ml-2" data-id="element-568" />}
          </h3>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-569">
            Requisitos obligatorios para marcar como Lead Cualificado.
          </p>
        </div>

        <div className="p-5 space-y-4" data-id="element-570">
          {checks.map(check => <div key={check.id} className="flex items-start" data-id="element-571">
              {check.passed ? <CheckCircle2 className="w-5 h-5 text-growthly-green mt-0.5 flex-shrink-0" data-id="element-572" /> : <Circle className="w-5 h-5 text-growthly-red/50 mt-0.5 flex-shrink-0" data-id="element-573" />}
              <div className="ml-3" data-id="element-574">
                <span className={`text-[14px] font-medium ${check.passed ? 'text-growthly-text' : 'text-growthly-muted'}`} data-id="element-575">
                  {check.id}. {check.label}
                </span>
                {!check.passed && <p className="text-[12px] text-growthly-red mt-0.5" data-id="element-576">
                    Falta completar este campo en la ficha.
                  </p>}
              </div>
            </div>)}
        </div>

        <div className="p-4 border-t border-white/5 bg-growthly-panel flex justify-end space-x-3" data-id="element-577">
          <button onClick={onClose} className="btn-secondary" data-id="element-578">
            Cancelar
          </button>
          <button onClick={onConfirm} disabled={!allPassed} className={`btn-primary ${allPassed ? 'bg-growthly-green text-white hover:bg-growthly-green/90' : 'bg-white/10 text-growthly-muted cursor-not-allowed hover:bg-white/10 hover:translate-y-0 hover:shadow-none'}`} data-id="element-579">
            Marcar como Cualificado
          </button>
        </div>
      </div>
    </div>;
}